
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/money-fortune/Loser",
      function () {
        return require("private-next-pages/money-fortune/Loser.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/money-fortune/Loser"])
      });
    }
  